import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import ToastNotification from '../ToastNotification/ToastNotification';
import RegisterPassword4 from '../RegisterPassword4/RegisterPassword4';

const RegisterPassword3 = () => {
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);

    // Estado para o Toast
    const [toast, setToast] = useState({ show: false, message: '', type: '' });

    // Estado utilizado para controlar o avanço para a próxima fase
        const [isValidated, setIsValidated] = useState(false); 

    const showMessage = (msg, type) => {
        setToast({ show: true, message: msg, type: type });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 5000);
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                // Extraindo o userId das claims
                setUserId(decoded.userId || decoded.sub);
            } catch (error) {
                console.error("Erro ao decodificar token:", error);
                showMessage("Sessão inválida. Por favor, reinicie o processo.", "error");
            }
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validação simples de igualdade de e-mail no front-end
        if (email !== confirmEmail) {
            showMessage("Os e-mails informados não coincidem.", "error");
            return;
        }

        setLoading(true);
        const token = localStorage.getItem('token');

        try {
            // Ambientes - Development: localhost:8443 - Homologation: phantomtech.com.br 
            const response = await axios.post(
                `https://phantomtech.com.br/AutomaTech/api/credentials/initEmailValidation?userId=${userId}`,
                { email: email },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (response.status === 200) {
                showMessage(response.data.message || "E-mail enviado com sucesso! Verifique sua caixa de entrada.", "success");
                // Aqui ocorre o disparo para o timer e prosseguimento para o Passo 4 após o sucesso
                setTimeout(() => {
                    setIsValidated(true); 
                }, 2000);
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Erro ao iniciar validação de e-mail.';
            showMessage(errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    };

    // LÓGICA + COMANDO PARA TROCA DE TELA
        if (isValidated) {
            return <RegisterPassword4 />;
        }

    return (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
            <ToastNotification
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />

            <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm border-primary">
                    <div className="card-body p-4">
                        
                        {/* Títulos Mantendo o Padrão */}
                        <h3 className="card-title text-center mb-1">Cadastramento de Senha - Passo 3</h3>
                        <p className="text-center text-muted mb-4">Validação de E-mail: digite o endereço de e-mail de sua preferência - não precisa ser o mesmo onde recebeu sua licença.
                            Você o utilizará no Login ao sistema.
                        </p>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label fw-bold small text-secondary">Informe e-mail</label>
                                <input
                                    type="email"
                                    className="form-control form-control-lg"
                                    placeholder="exemplo@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label className="form-label fw-bold small text-secondary">Repita o e-mail</label>
                                <input
                                    type="email"
                                    className="form-control form-control-lg"
                                    placeholder="mesmo e-mail acima"
                                    value={confirmEmail}
                                    onChange={(e) => setConfirmEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="d-grid mt-4">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary btn-lg fw-bold shadow-sm"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Enviando...
                                        </>
                                    ) : 'ENVIAR'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="text-center mt-3">
                    <small className="text-muted">
                        <i className="bi bi-envelope-check-fill me-1"></i>
                        Enviaremos um código de ativação para este e-mail.
                    </small>
                </div>
            </div>
        </div>
    );
};

export default RegisterPassword3;